export enum UnipageNavigatorAssessmentSource {
    CTA = "cta",
    POPUP = "popup",
    APP = "app",
}